(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elena-collection-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elena-card-options')) {
  customElements.define('elena-card-options', class extends HTMLElement {
    connectedCallback() {
      this.products = JSON.parse(this.querySelector('.elena-card-products').textContent);
      this.currentProduct = this.products[0];
      this.variants = this.currentProduct.variants;
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.type === 'radio') this.updateSelection();
      }, { signal: this.controller.signal });
      this.addEventListener('click', (event) => {
        const swatch = event.target instanceof Element ? event.target.closest('[data-group-product]') : null;
        if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const product = this.products.find(item => String(item.id) === swatch.dataset.groupProduct);
        if (!product) return;
        event.preventDefault();
        event.stopPropagation();
        this.selectProduct(product);
      }, { signal: this.controller.signal });
      this.updateSelection();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    selectProduct(product) {
      const oldSelections = new Map(Array.from(this.querySelectorAll('.elena-card-fields input:checked')).map(input => [input.name, input.value]));
      this.currentProduct = product;
      this.variants = product.variants;
      this.querySelector('.elena-card-fields').innerHTML = product.optionsHtml;
      for (const input of this.querySelectorAll('.elena-card-fields input')) {
        if (oldSelections.get(input.name) === input.value) input.checked = true;
      }
      for (const swatch of this.querySelectorAll('[data-group-product]')) {
        if (swatch.dataset.groupProduct === String(product.id)) swatch.setAttribute('aria-current', 'true');
        else swatch.removeAttribute('aria-current');
      }
      const formComponent = this.querySelector('product-form-component');
      formComponent.dataset.productId = product.id;
      const productInput = formComponent.querySelector('input[name="product-id"]');
      if (productInput) productInput.value = product.id;
      const card = this.closest('product-card');
      if (card) {
        card.dataset.productId = product.id;
        card.setAttribute('view-event-payload', typeof product.viewEvent === 'string' ? product.viewEvent : JSON.stringify(product.viewEvent));
        const titleLink = card.querySelector('[ref="productTitleLink"]');
        const title = titleLink?.querySelector('[role="heading"],h2,h3,p');
        if (title) title.textContent = product.title;
        const overlay = card.querySelector('[ref="productCardLink"]');
        overlay?.setAttribute('aria-label', product.title);
        const price = card.querySelector('product-price [ref="priceContainer"]');
        const priceDocument = new DOMParser().parseFromString(product.priceHtml, 'text/html');
        const newPrice = priceDocument.querySelector('[ref="priceContainer"]');
        if (price && newPrice) price.replaceChildren(...newPrice.childNodes);
        const gallery = card.querySelector('[ref="cardGallery"]');
        for (const [index, image] of Array.from(gallery?.querySelectorAll('img') || []).entries()) {
          const replacement = product.images[index] || product.images[0];
          if (!replacement) continue;
          image.src = replacement.src;
          image.srcset = replacement.src;
          image.alt = replacement.alt;
          image.width = replacement.width;
          image.height = replacement.height;
        }
        if (product.images[0]) card.dataset.featuredMediaUrl = product.images[0].src;
      }
      this.updateSelection();
    }
    updateSelection() {
      const fields = Array.from(this.querySelectorAll('fieldset[data-option-index]'));
      const selected = [];
      for (const field of fields) {
        const index = Number(field.dataset.optionIndex);
        for (const radio of field.querySelectorAll('input[type="radio"]')) {
          const available = this.variants.some(variant => variant.available && variant.options[index] === radio.value && selected.every((value, position) => !value || variant.options[position] === value));
          radio.disabled = !available;
          if (!available) radio.checked = false;
        }
        selected[index] = field.querySelector('input:checked')?.value || null;
      }
      const complete = selected.every(Boolean);
      const variant = complete ? this.variants.find(variant => variant.options.every((value, index) => !fields.length || value === selected[index])) : null;
      const idInput = this.querySelector('input[name="id"]');
      const button = this.querySelector('button[name="add"]');
      idInput.value = variant?.available ? variant.id : '';
      button.disabled = !variant?.available;
      this.querySelector('.elena-card-selection').textContent = variant?.available ? variant.price : this.variants.some(variant => variant.available) ? this.dataset.prompt : this.dataset.soldOut;
      const card = this.closest('product-card');
      if (typeof card?.applyVariantToLinks === 'function') card.applyVariantToLinks(variant?.available ? String(variant.id) : null, this.currentProduct.url);
      else if (card) {
        for (const link of card.querySelectorAll('[ref="productCardLink"],[ref="productTitleLink"],[ref="cardGalleryLink"]')) link.href = this.currentProduct.url;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
